import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 10px 2px;
  position: relative;
`;

const Label = styled.h5`
  opacity: 0.6;
  font-size: 13px;
  line-height: 20px;
  margin: 0;
  font-weight: normal;
`;

const Value = styled.span`
  font-size: 16px;
  line-height: 29px;
  letter-spacing: 0.03em;
  font-weight: bold;
`;

const SummaryItem = ({ label, value }) => {
  if (!value) {
    return null;
  }
  return (
    <Wrapper>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Wrapper>
  );
};

export default SummaryItem;
